import type { ViewLock } from "../app/storeTypes.ts";
import { VIEW_LOCK_BREAK_ANGLE_RAD, viewDeviationAngle } from "./viewLock.ts";

/**
 * Ignore only very small drift from damping / floating point noise so a
 * deliberate rotate drag feels immediate, while panning and dollying in a
 * locked view still remain locked.
 */
export const VIEW_LOCK_ORBIT_INTENT_ANGLE_RAD = (0.08 * Math.PI) / 180;

export type ViewLockOrbitChange = "locked" | "orbit-intent" | "break";

export function classifyViewLockOrbitChange(
  lock: ViewLock,
  position: [number, number, number],
  target: [number, number, number],
): ViewLockOrbitChange {
  const angle = viewDeviationAngle(lock.axis, lock.sign, position, target);
  if (angle > VIEW_LOCK_BREAK_ANGLE_RAD) return "break";
  if (angle > VIEW_LOCK_ORBIT_INTENT_ANGLE_RAD) return "orbit-intent";
  return "locked";
}
